export default {
  // baseUri: 'http://localhost:3090',
  // baseUri: 'https://api.via-trm-development.com',
  // baseUri: 'https://api.via-trm-demo.com',
  // baseUri: 'https://api.via-trm.com',
  // baseUri: 'https://api-auckland.via-trm.com',
  baseUri: 'https://api.via-trm-staging.com',
};
